module.exports = __webpack_public_path__ + "img/thuisbezorgd.dc1d866a.png";